<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #end>
        <!-- 导出按钮 -->
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`承运利润表`)">导出</el-button>
        </el-form-item>
        <!-- 查看全部车辆 -->
        <el-form-item class="viewAllBtn">
          <el-button type="primary" @click="goCarList">查看全部车辆</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import Wxts from '../../../components/Wxts.vue';
export default {
  mixins: [tableMixin],
  components: { Wxts },
  data() {
    return {
      baseUrl: 'pcustom',
      getListUrl: 'profit',
      breadcrumb: [
        { name: "财务管理" },
        { name: "承运利润表" },
      ],
      wxtsList: [
        {
          name: '净利润=应收运费-应付运费-附加费用'
        }
      ],
      formInline: {
        month: '',
        p_id: null,
      },
      formCtrl: [
        {
          ...this.ctrls.month,
        },
        {
          label: "承运公司",
          keyName: "p_id",
          placeholder: "请选择承运公司",
          type: "select",
          options: [],
        },
      ],
      cols: [
        { keyName: "company", label: "承运公司", minwidth: 150 },
        { keyName: "ys_freight", label: "应收运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "yf_freight", label: "应付运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', width: 110 },
        { keyName: "additional_fees", label: "附加费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "compen", label: "运单补差", align: 'right', className: 'pr30', width: 110 },
        { keyName: "profit", label: "净利润", align: 'right', className: 'pr30', width: 110 },
      ],
      getTotalProperty: [
        'ys_freight',
        'yf_freight',
        'kuitotal',
        'additional_fees',
        'compen',
        'profit',
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            console.log(id)
            let path = `/finance/carrierProfitCarList`
            const query = {
              p_id: id,
            }
            if (this.formInline.month) {
              query['month'] = this.formInline.month
            }
            this.$router.push({
              path,
              query,
            })
          },
        },
      ],
      baseParams: ['month'],
    };
  },
  methods: {
    goCarList() {
      let path = `/finance/carrierProfitAllCarList`
      this.$router.push({
        path,
      })
    },
    setOptions({ data }) {
      this.formCtrl.map(v => {
        if (v.keyName == 'p_id' && data && data.length) {
          this.setCtrlOption(v, data, 'company')
        }
      })
      this.$forceUpdate()
    },
  },
  created() {
    this.MONTH = this.CURR_MONTH
    this.$set(this.formInline, 'month', this.CURR_MONTH)
  },
  mounted() {
    this.getOptions()
    this.getList()
  },
};
</script>

<style lang="less" scoped>
/deep/ .retrieval {
  .viewAllBtn {
    .el-button {
      width: 100px;
    }
  }
}
</style>